module.exports = __webpack_public_path__ + "static/media/room-service.7f820dd1.svg";